export default __webpack_public_path__ + "static/media/pvt.92ddf9fe.png";